export default {
  // meet_big: {
  //   overlay:
  //     "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
  //   container:
  //     "w-full md:w-[755px] h-[100dvh] md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper overflow-hidden md:rounded-[24px] pt-8 md:pt-12 pb-[calc(2rem+env(safe-area-inset-bottom))]",
  //   header: "relative flex justify-between items-center px-4 md:px-6 mb-4",
  //   closeButton: "absolute right-4 md:right-6 lg:right-6 top-1 z-10",
  //   closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
  //   title:
  //     "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text leading-tight my-0",
  //   headerContent: "flex items-center",
  //   contentWrapper:
  //     "w-full h-full max-h-[calc(100dvh-12rem-env(safe-area-inset-bottom))] overflow-y-auto scrollbar-thin scrollbar-thumb-gray_3 scrollbar-track-paper px-4",
  //   content: "w-full h-full md:px-6 md:pb-4",
  // },
  
  //Used for Success, MagicLink, Provider, etc.
  transfer_medium: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
    container:
      "w-full md:w-[755px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper md:rounded-[24px] flex flex-col overflow-hidden",
    header: "relative flex justify-between items-center px-6 md:px-8 pt-5 pb-3 shrink-0",
    closeButton: "absolute right-4 md:right-6 top-4 z-10",
    closeIcon: "h-7 w-7 text-text_secondary hover:text-text",
    title:
      "flex-1 text-[20px] md:text-[24px] xl:text-[28px] font-bold text-text text-left leading-tight my-0 pr-10",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper",
    content: "px-6 md:px-8 py-4",
    footer: "px-6 md:px-8 py-4 bg-paper border-t border-bordered",
  },

  // meet_wide: {
  //   overlay:
  //     "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
  //   container:
  //     "bg-paper overflow-hidden rounded-[24px] py-0 md:mx-4",
  //   header: "relative flex justify-between items-center",
  //   closeButton: "absolute top-4 right-4 z-10",
  //   closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
  //   title: "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text leading-tight my-0",
  //   headerContent: "flex items-center",
  //   contentWrapper: "w-full h-full px-0",
  //   content: "w-full h-full",
  // },

  transfer_compact: {
    overlay: "fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 z-50",
    container: "w-full max-w-md max-h-[85vh] flex flex-col bg-paper rounded-2xl shadow-xl overflow-hidden",
    header: "relative flex items-center min-h-[2.5rem] px-6 pt-5 pb-2 shrink-0",
    closeButton: "absolute right-4 top-4 p-1 rounded text-text_secondary hover:text-text transition-colors z-10",
    closeIcon: "h-5 w-5",
    title: "text-base md:text-lg font-bold text-text pr-8",
    headerContent: "flex items-center gap-2",
    contentWrapper: "flex-1 min-h-0 overflow-y-auto",
    // Padding lives on `content` (not contentWrapper) because the footer-mode
    // render path in Modal bypasses contentWrapper and only honors `content`.
    content: "flex flex-col px-6 py-4",
    footer: "px-6 py-4 bg-paper border-t border-bordered",
  },

  transfer_fullscreen: {
    overlay: "fixed inset-0 flex flex-col z-50",
    container: "relative bg-paper flex flex-col flex-1 min-h-0 w-full",
    header: "relative flex items-center gap-2 px-6 py-2 shrink-0 border-b border-bordered",
    closeButton: "shrink-0 flex order-last p-1.5 text-text_secondary hover:text-text transition z-10",
    closeIcon: "h-5 w-5",
    title: "flex-1 min-w-0 text-sm font-bold text-text text-center truncate py-1 md:text-base",
    headerContent: "shrink-0 flex items-center order-first",
    contentWrapper: "flex-1 min-h-0 overflow-y-auto flex flex-col",
    content: "flex flex-col flex-1 min-h-0",
  },
}
